export default __webpack_public_path__ + "static/media/ux-interface.84694eea.svg";